module.exports = __webpack_public_path__ + "static/media/tools-timer.f9bde45b.svg";